<template>
  <div
    class="exam"
    style="-moz-user-select:none;"
    v-loading="loading"
    element-loading-text="加载中,请稍后..."
  >
    <el-container>
      <!-- 考试时间安排 -->
      <el-header height="auto">
        <div height="60px"></div>
      </el-header>

      <el-main v-if="ques.length != 0">
        <!-- 题型、分数 -->
        <div class="publicDesc">
          <span class="examGrade">
            <strong>{{ i + 1 }}</strong>
            <strong>/{{ ques.length }}</strong>
            <!-- <span>{{currentQues.queType}}（分值：{{currentQues.score}}分）</span> -->
          </span>
          <!-- <span>总分：{{exam.score}}</span> -->
        </div>
        <el-progress
          :percentage="progress"
          type="line"
          :show-text="false"
        ></el-progress>
        <!--折叠面板  -->
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" title="查看答题卡">
            <el-row>
              <el-col :span="4" v-for="(item, index) in ques" :key="index">
                <el-button
                  :type="item.circleColor"
                  circle
                  @click="toQuestion(index)"
                  >{{ index + 1 }}</el-button
                >
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
        <!-- 题目 -->
        <div class="content">
          <div class="queTitle">
            <p>
              <strong>{{ i + 1 }}.</strong>
            </p>
            <div class="queName" v-html="currentQues.name"></div>
          </div>

          <div class="answers">
            <div v-for="(item, index) in currentQues.options" :key="index">
              <div v-if="currentQues.type == 2">
                <p
                  class="option"
                  :class="{ bgGreen: item.greenBg, bgRed: item.redBg }"
                >
                  <el-checkbox
                    fill="#999"
                    v-model="currentQues.is_select"
                    @change="
                      (val) => {
                        fun(val, item);
                      }
                    "
                    :label="item.id"
                    :disabled="disabled"
                  >
                    <span></span>
                  </el-checkbox>
                  <span>{{ code[index] }}.{{ item.name }}</span>
                </p>
              </div>
              <div v-else>
                <p
                  class="option"
                  :class="{ bgGreen: item.greenBg, bgRed: item.redBg }"
                >
                  <el-radio
                    v-model="currentQues.is_select"
                    @change="
                      (val) => {
                        fun(val, item);
                      }
                    "
                    :label="item.id"
                    :disabled="disabled"
                  >
                    <span></span>
                  </el-radio>
                  <span>{{ code[index] }}.{{ item.name }}</span>
                </p>
              </div>
            </div>
            <!-- <p v-show="currentQues.parsing">答案解析：{{currentQues.parsing}}</p> -->
          </div>
          <div class="footer">
            <el-button
              type
              round
              size="small"
              @click="delQue(currentQues.question_id)"
              >从错题集删除该题</el-button
            >
            <el-button
              type
              round
              size="small"
              v-show="i > 0"
              @click="preQuestion"
              >上一题</el-button
            >
            <el-button
              type="primary"
              round
              size="small"
              v-show="i < ques.length - 1"
              @click="nextQuestion"
              >下一题</el-button
            >
          </div>
          <div class="submit">
            <el-button type="primary" @click="showAnswer(currentQues)"
              >查看答案</el-button
            >
            <el-button type="warning" @click="toClearRecord"
              >清空记录重新答题</el-button
            >
          </div>
        </div>
      </el-main>
      <el-main v-else>暂时没有错题</el-main>
      <!-- <el-model>
      </el-model>-->
    </el-container>
    <Result
      :result="result"
      :type="exam.type"
      v-if="showResult"
      @checkPaper="checkPaper"
      @resetPaper="resetPaper"
    ></Result>
  </div>
</template>
<script>
import Result from "./result";
import { shuffle } from "../assets/js/const.js";
import { isios } from "../components/js/isIos.js";
let that = this;
export default {
  data() {
    return {
      exam: {},
      ques: [],
      i: 0, //当前题目的索引
      sum: 0, //总分
      code: ["A", "B", "C", "D", "E", "F", "G"],
      progress: 0, //进度条
      showResult: false, //展示结果
      submitBtn: true, //控制交卷按钮显示与否
      disabled: false, //选项可选与否
      result: {},
      currentQues: {}, //当前题目
      useMinute: 0,
      useSecond: 0,
      timer: null, //定时器
      endTimer: null,
      obj: {},
      activeNames: [],
      resetBtn: false,
      disabledBtn: false,
      countdown: 0,
      num: 0,
      loading: true,
    };
  },
  components: { Result },

  watch: {
    $route: "toRefresh",
  },

  created() {
    that = this;
    this.init();
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
  },
  methods: {
    init() {
      //初始化试卷信息
      let _this = this;
      let id = "rootid";
      if (_this.Storage.getStorage(id)) {
        //判断本地存储有没有exam和ques如果有则直接赋值，没有则请求接口
        _this.obj = _this.Storage.getStorage(id);
        _this.exam = _this.Storage.getStorage(id).exam;
        _this.ques = _this.Storage.getStorage(id).ques;
        _this.progress = this.Storage.getStorage(id).progress;
        _this.currentQues = _this.ques[0];
        _this.loading = false;
      } else {
        _this.obj = {};
        _this.useMinute = 0;
        _this.useSecond = 0;
        this.$http
          .get(process.env.VUE_APP_API_URL + "wrong")
          .then(function(data) {
            _this.loading = false;

            if (data.data.code == 200) {
              //顺序答题
              _this.exam = data.data.data;
              // _this.Storage.setStorage('exam'+id,_this.exam);
              _this.obj.exam = _this.exam;
              let ques = data.data.data.question;
              ques.forEach((item) => {
                if (item.type == 2) {
                  item.is_select = [];
                } else {
                  item.is_select = "";
                }
                switch (item.type) {
                  case 1:
                    item.queType = "单选题";
                    break;
                  case 2:
                    item.queType = "多选题";
                    break;
                  case 3:
                    item.queType = "判断题";
                    break;
                  case 4:
                    item.queType = "填空题";
                    break;
                }
              });
              if (_this.exam.is_random) {
                //判断题目是否随机
                ques = shuffle(ques);
              }
              if (_this.exam.is_option_random) {
                //判断题目选项是否随机
                ques.forEach((item) => {
                  item.options = shuffle(item.options);
                });
              }
              _this.ques = JSON.parse(JSON.stringify(ques));
              //_this.Storage.setStorage('ques'+id,_this.ques);
              _this.obj.ques = _this.ques;
              _this.currentQues = _this.ques[0];
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function(error) {
            _this.loading = false;

            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            console.log(error);
            return;
          });
      }
    },

    preQuestion() {
      //上一题
      this.i -= 1;
      this.currentQues = this.ques[this.i];
    },
    nextQuestion() {
      //下一题
      this.i += 1;
      this.currentQues = this.ques[this.i];
    },
    toQuestion(i) {
      //跳转到某一题
      this.i = i;
      this.activeNames = [];
      this.currentQues = this.ques[this.i];
    },
    delQue(id) {
      //删除试题
      let _this = this;
      console.log(id);
      this.$confirm("确定要从错题集中删除该道试题吗？", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        closeOnClickModal: false,
      })
        .then(() => {
          that.$http
            .post(process.env.VUE_APP_API_URL + "del", { id: id })
            .then(function(data) {
              if (data.data.code == 200) {
                that.$message.success(data.data.msg);
                that.obj.ques.forEach((item, index) => {
                  if (item.question_id == id) {
                    that.obj.ques.splice(index, 1);
                  }
                  that.i = 0;
                  if (that.obj.ques.length > 0) {
                    that.Storage.setStorage("rootid", that.obj);
                  } else {
                    that.Storage.delStorage("rootid");
                  }
                });

                that.init();
              } else {
                that.$message.error(data.data.msg);
              }
            })
            .catch(function(error) {
              that.$message.error({ message: "网络错误,请刷新界面重试" });
              console.log(error);
              return;
            });
        })
        .catch(() => {
          that.$message.warning("已取消，点击答题卡可查看未做题目！");
        });
    },
    toRefresh() {
      window.location.href("");
    },
    showAnswer(que) {
      // this.$message.error('error')
      let options = que.options; //拿到每道题的可选项
      let arr = [];

      options.forEach((option) => {
        //标记所有题目的正确选项
        option.greenBg = false;
        option.redBg = false;
        if (option.is_right) {
          option.bgColor = true;
          option.greenBg = true;
          arr.push(option.id);
        }
      });

      let select = false;
      if (que.type == 2 && que.is_select.length != 0) {
        select = true;
        let len = que.is_select.length;
        if (len == arr.length) {
          arr.forEach((i) => {
            if (que.is_select.indexof(i) != -1) {
              que.is_right = true;
            } else {
              que.is_right = false;
              return;
            }
          });
        } else {
          que.is_right = false;
        }
      } else if (que.type != 2 && que.is_select != "") {
        select = true;
        if (arr[0] == que.is_select) {
          que.is_right = true;
        } else {
          que.is_right = false;
        }
      }
      if (!que.is_right && select) {
        //如果做错了题
        que.circleColor = "danger"; //根据得分情况以及选择与否改变答题卡的颜色
        options.forEach((option) => {
          //如果做错了题，将错题标记

          if (que.type == 1 || que.type == 3) {
            console.log(que);
            if (option.id == que.is_select) {
              option.bgColor = true;
              option.redBg = true;
            }
          } else if (que.type == 2) {
            que.is_select.forEach((i) => {
              if (!option.is_right && option.id == i) {
                //如果选项是错的，但是选择的选择与该选项的id一样，那么标红
                option.bgColor = true;
                option.redBg = true;
              }
            });
          }
        });
      } else if (que.is_right) {
        que.circleColor = "success";
      }
      this.Storage.setStorage("rootid", this.obj);
      this.$forceUpdate();
    },
    toClearRecord() {
      let _this = this;
      this.$confirm("此操作将清除所有答题记录", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
      })
        .then(() => {
          _this.progress = 0;
          _this.i = 0;
          _this.Storage.delStorage("rootid");
          _this.init();
        })
        .catch(() => {
          _this.disabledBtn = false;
          _this.$message.warning("已取消，可继续答题！");
        });
    },
    fun(val, option) {
      let question = this.currentQues,
        exam = this.ques,
        type = question.type,
        i = 0;

      if (type == 1 || type == 3) {
        //默认单选判断一经触发该方法状态即为选中
        question.check = true;
        question.circleColor = "primary";
      } else {
        if (question.is_select.length > 0) {
          question.check = true;
          question.circleColor = "primary"; //通过判断value来判断是否选择了该题目
        } else {
          question.check = false;
          question.circleColor = "default";
        }
      }
      exam.forEach((item) => {
        if (item.check) {
          i++;
        }
      });
      this.progress = (i / exam.length) * 100;
      // this.Storage.setStorage('ques'+id,this.ques);
      // this.Storage.setStorage('progress'+id,this.progress);
      this.obj.ques = this.ques;
      this.obj.progress = this.progress;
      this.Storage.setStorage("rootid", this.obj);
    },
  },
};
</script>
>
<style lang="less" scope>
.el-collapse-item__header {
  line-height: 40px !important;
  height: 40px !important;
  display: block !important;
  text-align: center;
  color: #1890ff !important;
}
.el-message-box {
  width: 80% !important;
}
.exam {
  max-width: 1000px;
  margin: 0 auto;
  // background-image:url('../assets/bg.png');
  background-image: linear-gradient(#096dd9, #83bdf9);
  padding-bottom: 20px;
  background-size: 100% 100%;
  font-size: 14px;
  position: relative;
  overflow-y: atuo;
  height: 100%;
  .el-header {
    padding: 10px;
    .el-row {
      text-align: left;
      padding: 5px;
      color: #fff;
      font-size: 13px;
    }
  }
  .el-main {
    border-radius: 8px;
    background: #fff;
    margin: 0 10px;
    .publicDesc {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
      .examGrade > strong {
        font-size: 16px;
      }
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      .queTitle {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        font-size: 18px;
      }
    }
    .el-collapse {
      border: none !important;
      .el-col {
        padding: 3px;
        .el-button {
          width: 40px;
          height: 40px;
          text-align: center;
          padding: 5px;
        }
      }
    }
    .radioAnswer {
      padding: 5px;
    }
    .answers {
      min-height: 280px;
      .option {
        margin: 0;
        padding: 8px 0;
        display: flex;
        height: auto;
        overflow: hidden;
        word-break: break-all;
        overflow-wrap: break-word;
        font-size: 17px;
        line-height: 17px;
      }
    }
    .footer {
      text-align: right;
    }
    .submit {
      padding-top: 40px;
      text-align: center;
    }
  }
}
// 未选中样式

.bgRed {
  background-color: #fff1f2;
  color: #f93a4e;
}
.bgGreen {
  background-color: #edfffd;
  color: #1ca194 !important;
}
.el-radio__input.is-disabled + span.el-radio__label,
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #666 !important;
}
.bgGreen .el-radio__input.is-disabled + span.el-radio__label,
.bgGreen .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #1ca194 !important;
}
.bgRed .el-radio__input.is-disabled + span.el-radio__label,
.bgRed .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #f93a4e !important;
}
.bgGreen .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
.bgRed .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
.bgRed .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after,
.bgGreen .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  background-color: #000;
}
.el-radio {
  margin-right: 0 !important;
  .el-radio__inner {
    border-color: #999;
  }
}
.el-checkbox {
  .el-checkbox__inner {
    border-color: #999;
  }
}
.el-radio__input.is-disabled .el-radio__inner,
.el-radio__input.is-disabled.is-checked .el-radio__inner,
.el-checkbox__input.is-disabled .el-checkbox__inner {
  border-color: #999 !important;
}
.el-button--danger {
  background-color: #f93a4e !important;
}
.el-button--success {
  background-color: #1ca194 !important;
}
.el-radio__label,
.el-checkbox__label {
  font-size: 16px !important;
}
.el-collapse-item__header {
  font-size: 16px !important;
}
.queName {
  line-height: 20px;
  font-size: 18px;
}
@media screen and (min-device-width: 600px) {
  .el-message-box {
    width: 400px !important;
  }
}
</style>
